/* BYC Urban — small, dependency-free behaviours */
(function () {
  'use strict';

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '€{{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimals = parts[1] === '00' ? withCommas : withCommas + '.' + parts[1];
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount\s*\}\}/, noDecimals);
  }

  /* Close the mobile drawer with Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details.drawer[open], details[data-search][open]').forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.focus();
    });
  });
  document.addEventListener('click', function (e) {
    if (e.target.matches('.drawer__overlay') || e.target.closest('[data-drawer-close]')) {
      var d = e.target.closest('details.drawer');
      if (d) d.removeAttribute('open');
    }
  });

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var step = parseInt(btn.getAttribute('data-qty'), 10);
    var min = parseInt(input.getAttribute('min') || '0', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Auto-submit collection filters */
  document.querySelectorAll('form[data-filters]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="number"]')) return;
      form.submit();
    });
  });
  document.querySelectorAll('select[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* Language picker */
  document.querySelectorAll('select[data-autosubmit]').forEach(function (select) {
    select.addEventListener('change', function () { select.form.submit(); });
  });

  /* Product gallery */
  function showMedia(root, id) {
    if (!root || !id) return;
    var found = false;
    root.querySelectorAll('[data-media-id]').forEach(function (slide) {
      var on = slide.getAttribute('data-media-id') === String(id);
      if (on) found = true;
      slide.classList.toggle('is-active', on);
    });
    if (!found) return;
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', t.getAttribute('data-thumb') === String(id) ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]');
    if (!t) return;
    showMedia(t.closest('[data-gallery]'), t.getAttribute('data-thumb'));
  });

  /* Variant picker */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var json = root.querySelector('script[data-product-json]');
    if (!json) return;
    var product = JSON.parse(json.textContent);
    var form = root.querySelector('form[data-product-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var addBtn = form && form.querySelector('[data-add]');
    var priceEl = root.querySelector('[data-price]');
    var gallery = document.querySelector('[data-gallery]');

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option]'), function (fs) {
        var checked = fs.querySelector('input:checked');
        var label = fs.querySelector('[data-option-value]');
        if (checked && label) label.textContent = checked.value;
        return checked ? checked.value : null;
      });
    }
    function findVariant(values) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === values[i]; });
      });
    }
    function update() {
      var variant = findVariant(selected());
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = window.theme.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
      }
      if (priceEl) {
        var html = '';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html = '<span class="price__sale">' + formatMoney(variant.price) + '</span><s>' + formatMoney(variant.compare_at_price) + '</s>';
        } else {
          html = '<span>' + formatMoney(variant.price) + '</span>';
        }
        priceEl.innerHTML = html;
      }
      if (variant.featured_media && gallery) showMedia(gallery, variant.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option]')) update();
    });
  });

  /* Product recommendations (loaded after page render) */
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) {
          el.innerHTML = fresh.innerHTML;
        } else {
          el.closest('.shopify-section') && el.closest('.shopify-section').remove();
        }
      })
      .catch(function () {});
  });
})();
